/**
 * Publish Your Ad With Plate Route - React Router v7
 *
 * Route: /publicar/matricula/
 * Description: Publish ad by entering license plate number
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, @typescript-eslint/no-unused-vars */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {useLoaderData} from 'react-router-dom'

import PublishYourAdWithPlate from './index.js'

// Import styles
import './styles/index.scss'

/**
 * Loader for Publish Your Ad With Plate page
 * Fetches SEO data and page name
 */
export async function loader({context, request}: LoaderFunctionArgs) {
  const {domain, i18n} = context
  const {culture} = i18n
  const url = new URL(request.url)
  const path = url.pathname

  try {
    const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

    const [, seoData] = await domain.get('get_seo_data_use_case').execute({
      culture,
      pageName
    })

    return {
      h1: seoData?.h1 || '',
      helmet: seoData?.head || {},
      pageName
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[PublishYourAdWithPlate] Loader error:', error)
    return {
      h1: '',
      helmet: {},
      pageName: 'publish_your_ad_with_plate'
    }
  }
}

/**
 * Component wrapper
 * Uses existing PublishYourAdWithPlate component
 */
export function Component() {
  const data = useLoaderData()
  return <PublishYourAdWithPlate {...data} />
}

export default {loader, Component}
